import React, { useEffect, useState } from "react";
import { getImageUrl } from "../imageUrl";

import {
  MdClose,
  MdSend,
  MdDescription,
  MdPerson,
  MdPhone,
  MdEmail,
  MdAttachFile,
  MdDeleteOutline,
  MdImage,
  MdOutlinePersonSearch,
} from "react-icons/md";


export default function EditQuery({
  closeModal,
  onUpdate,

  queryHeading,
  queryDescription,
  email,
  mobile,
  building_block,
  image,
  requested_department_user,
  requestedDepartment,
  assignedDepartment,
  priority,
  departments,


  setRequestedDepartment,
  setAssignedDepartment,
  setPriority,
  setQueryHeading,
  setQueryDescription,
  setEmail,
  setMobile,
  setBuildingBlock,
  setRequestedDepartmentUser,

  selectedImage,
  setSelectedImage,
}) {
  const API = process.env.REACT_APP_API_URL;

  const [error, setError] = useState("");
  const [queryHeadings, setQueryHeadings] = useState([]);
  const [loadingHeadings, setLoadingHeadings] = useState(true);

  // =========================================================
  // PREVENT BACKGROUND SCROLL
  // =========================================================

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const fetchQueryHeadings = async () => {
      try {
        setLoadingHeadings(true);

        const response = await fetch(
          `${API}/api/query-headings/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Unable to load query headings");
        }

        setQueryHeadings(await response.json());
      } catch (err) {
        console.log("Error fetching query headings:", err);
        setError("Unable to load query headings.");
      } finally {
        setLoadingHeadings(false);
      }
    };

    fetchQueryHeadings();
  }, [API]);

  // =========================================================
  // SELECT IMAGE
  // =========================================================

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      return;
    }

    // 5 MB validation
    if (file.size > 5 * 1024 * 1024) {
      setError(
        "Image size must be less than 5 MB."
      );

      e.target.value = "";
      return;
    }

    setError("");
    setSelectedImage(file);
  };

  // =========================================================
  // REMOVE SELECTED IMAGE
  // =========================================================

  const removeSelectedImage = () => {
    setSelectedImage(null);

    const input =
      document.getElementById(
        "edit-query-image"
      );

    if (input) {
      input.value = "";
    }
  };

  // =========================================================
  // VALIDATE
  // =========================================================

  const handleUpdate = () => {
    setError("");

    if (!queryHeading?.trim()) {
      setError(
        "Query heading is required."
      );
      return;
    }

    if (!queryDescription?.trim()) {
      setError(
        "Query description is required."
      );
      return;
    }

    // if (!email?.trim()) {
    //   setError("Email is required.");
    //   return;
    // }

    // if (!mobile?.trim()) {
    //   setError("Mobile number is required.");
    //   return;
    // }

    onUpdate();
  };

  // =========================================================
  // EXISTING IMAGE URL
  // =========================================================

  const existingImageUrl = getImageUrl(image, API);

  // =========================================================
  // SELECTED IMAGE PREVIEW
  // =========================================================

  const selectedImageUrl =
    selectedImage instanceof File
      ? URL.createObjectURL(selectedImage)
      : null;

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div
      className="fixed inset-0 z-[100] bg-slate-950/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-5"
      onClick={closeModal}
    >

      {/* =====================================================
          MODAL
      ===================================================== */}

      <div
        className="relative w-full max-w-2xl max-h-[94vh] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col"
        onClick={(e) =>
          e.stopPropagation()
        }
      >

        {/* ===================================================
            HEADER
        =================================================== */}

        <div
          className="flex items-center justify-between px-5 sm:px-6 py-4 border-b border-slate-200 bg-white flex-shrink-0"
        >

          <div className="flex items-center gap-3">

            <div
              className="w-10 h-10 rounded-xl bg-sky-50 text-sky-600 flex items-center justify-center"
            >
              <MdDescription size={22} />
            </div>

            <div>

              <h2 className="text-lg font-bold text-slate-800">
                Edit Query
              </h2>

              <p className="text-xs text-slate-500 mt-0.5">
                Update query information
              </p>

            </div>

          </div>

          {/* CLOSE */}

          <button
            type="button"
            onClick={closeModal}
            className="w-9 h-9 rounded-lg flex items-center justify-center text-slate-400 hover:bg-slate-100 hover:text-slate-700 transition"
          >
            <MdClose size={22} />
          </button>

        </div>

        {/* ===================================================
            CONTENT
        =================================================== */}

        <div className="overflow-y-auto">

          <div className="p-5 sm:p-6 space-y-6">

            {/* =================================================
                ERROR
            ================================================= */}

            {error && (

              <div
                className="flex items-center justify-between gap-3 p-3 rounded-lg border border-red-200 bg-red-50 text-red-700"
              >

                <p className="text-sm font-medium">
                  {error}
                </p>

                <button
                  type="button"
                  onClick={() =>
                    setError("")
                  }
                  className="text-red-400 hover:text-red-600"
                >
                  <MdClose size={17} />
                </button>

              </div>

            )}

            {/* =================================================
                CONTACT INFORMATION
            ================================================= */}

            <div>

              <div className="flex items-center gap-2 mb-3">

                <div
                  className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center"
                >
                  <MdPerson size={18} />
                </div>

                <div>

                  <h3 className="text-sm font-semibold text-slate-800">Contact Information</h3>

                  {/* <p className="text-xs text-slate-400">
                    Update contact details
                  </p> */}

                </div>

              </div>

              <div
                className="grid grid-cols-1 sm:grid-cols-2 gap-4"
              >

                {/* EMAIL */}

                {/* <div>

                  <label
                    htmlFor="edit-email"
                    className="block text-xs font-semibold text-slate-600 mb-1.5"
                  >
                    Email
                    <span className="text-red-500 ml-1">
                      *
                    </span>
                  </label>

                  <div className="relative">

                    <MdEmail
                      size={18}
                      className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                    />

                    <input
                      id="edit-email"
                      type="email"
                      value={email || ""}
                      onChange={(e) => {
                        setEmail(
                          e.target.value
                        );
                        setError("");
                      }}
                      placeholder="Enter email"
                      className="w-full h-10 pl-10 pr-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
                    />

                  </div>

                </div> */}

                {/* MOBILE */}

                {/* <div>

                  <label
                    htmlFor="edit-mobile"
                    className="block text-xs font-semibold text-slate-600 mb-1.5"
                  >
                    Mobile
                    <span className="text-red-500 ml-1">
                      *
                    </span>
                  </label>

                  <div className="relative">

                    <MdPhone
                      size={18}
                      className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                    />

                    <input
                      id="edit-mobile"
                      type="tel"
                      value={mobile || ""}
                      onChange={(e) => {
                        setMobile(
                          e.target.value
                        );
                        setError("");
                      }}
                      placeholder="Enter mobile"
                      className="w-full h-10 pl-10 pr-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
                    />

                  </div>

                </div> */}

              </div>

            </div>

            {/* =================================================
                REQUESTED USER
            ================================================= */}

            <div>

              <label
                htmlFor="requested-department-user"
                className="block text-xs font-semibold text-slate-600 mb-1.5"
              >
                Requested User
              </label>

              <div className="relative">

                <MdOutlinePersonSearch
                  size={19}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                />

                <input
                  id="requested-department-user"
                  type="text"
                  value={
                    requested_department_user ||
                    ""
                  }
                  onChange={(e) => {
                    setRequestedDepartmentUser(
                      e.target.value
                    );
                    setError("");
                  }}
                  placeholder="Enter requested user name"
                  className="w-full h-10 pl-10 pr-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 placeholder:text-slate-400 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
                />

              </div>

            </div>

            <div>

    <label
        htmlFor="edit-requested-department"
        className="block text-xs font-semibold text-slate-600 mb-1.5"
    >
        Requested Department
    </label>

    <div className="relative">

      <input
                  id="edit-requested-department"
                  type="text"
                  value={
                    requestedDepartment ||
                    ""
                  }
                  onChange={(e) => {
                    setRequestedDepartment(
                      e.target.value
                    );
                    setError("");
                  }}
                  placeholder="Enter requested department"
                  className="w-full h-10 pl-10 pr-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 placeholder:text-slate-400 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
                />

        {/* <select
            id="edit-requested-department"
            value={requestedDepartment || ""}
            onChange={(e) => {
                setRequestedDepartment(
                    e.target.value
                );
            }}
            className="w-full h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
        >

            <option value="">
                Select requested department
            </option>

            {departments.map((dept) => (
                <option
                    key={dept.id}
                    value={String(dept.id)}
                >
                    {dept.name}
                </option>
            ))}

        </select> */}

    </div>

</div>

<div>

    <label
        htmlFor="edit-priority"
        className="block text-xs font-semibold text-slate-600 mb-1.5"
    >
        Priority
    </label>

    <select
        id="edit-priority"
        value={priority || "Medium"}
        onChange={(e) => {
            setPriority(
                e.target.value
            );
        }}
        className="w-full h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
    >

        <option value="Low">
            Low
        </option>

        <option value="Medium">
            Medium
        </option>

        <option value="High">
            High
        </option>

    </select>

</div>

            <div>

              <label
                htmlFor="building-block"
                className="block text-xs font-semibold text-slate-600 mb-1.5"
              >
                Building Block
              </label>

              <div className="relative">
                <input
                  id="building-block"
                  type="text"
                  value={building_block || ""}
                  onChange={(e) => {
                    setBuildingBlock(e.target.value);
                    setError("");
                  }}
                  placeholder="Enter building / block"
                  className="w-full h-10 pl-10 pr-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 placeholder:text-slate-400 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
                />
              </div>

            </div>

            <div>

    <label
      htmlFor="edit-assigned-department"
        className="block text-xs font-semibold text-slate-600 mb-1.5"
    >
        Assigned Department
    </label>

    <div className="relative">

     

        <select
      id="edit-assigned-department"
      value={assignedDepartment || ""}
            onChange={(e) => {
        setAssignedDepartment(
                    e.target.value
                );
            }}
            className="w-full h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 outline-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
        >

            <option value="">
                Select Assigned department
            </option>

            {departments.map((dept) => (
                <option
                    key={dept.id}
                    value={String(dept.id)}
                >
                    {dept.name}
                </option>
            ))}

        </select>

    </div>

</div>

            {/* =================================================
                QUERY DETAILS
            ================================================= */}

            <div>

              <div className="flex items-center gap-2 mb-3">

                <div
                  className="w-8 h-8 rounded-lg bg-sky-50 text-sky-600 flex items-center justify-center"
                >
                  <MdDescription size={18} />
                </div>

                <div>

                  <h3 className="text-sm font-semibold text-slate-800">
                    Query Details
                  </h3>

                  <p className="text-xs text-slate-400">
                    Update the issue information
                  </p>

                </div>

              </div>

              <div className="space-y-4">

                {/* HEADING */}

                <div>

                  <label
                    htmlFor="edit-query-heading"
                    className="block text-xs font-semibold text-slate-600 mb-1.5"
                  >
                    Query Heading
                    <span className="text-red-500 ml-1">
                      *
                    </span>
                  </label>

                  <select
                    id="edit-query-heading"
                    value={queryHeading || ""}
                    onChange={(e) => {
                      setQueryHeading(
                        e.target.value
                      );
                      setError("");
                    }}
                    className="w-full h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 outline-none appearance-none cursor-pointer focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 disabled:opacity-60 disabled:cursor-not-allowed transition"
                    disabled={loadingHeadings}
                  >
                    {!queryHeading && (
                      <option value="">
                        {loadingHeadings
                          ? "Loading query headings..."
                          : "Select query heading"}
                      </option>
                    )}

                    {queryHeading && !queryHeadings.some(
                      (heading) => heading.name === queryHeading
                    ) && (
                      <option value={queryHeading}>
                        {queryHeading}
                      </option>
                    )}

                    {queryHeadings.map((heading) => (
                      <option
                        key={heading.id}
                        value={heading.name}
                      >
                        {heading.name}
                      </option>
                    ))}
                  </select>

                </div>

                {/* DESCRIPTION */}

                <div>

                  <div className="flex items-center justify-between mb-1.5">

                    <label
                      htmlFor="edit-query-description"
                      className="text-xs font-semibold text-slate-600"
                    >
                      Description
                      <span className="text-red-500 ml-1">
                        *
                      </span>
                    </label>

                    <span className="text-[11px] text-slate-400">
                      {queryDescription?.length || 0} characters
                    </span>

                  </div>

                  <textarea
                    id="edit-query-description"
                    rows={5}
                    value={
                      queryDescription || ""
                    }
                    onChange={(e) => {
                      setQueryDescription(
                        e.target.value
                      );
                      setError("");
                    }}
                    placeholder="Describe your issue..."
                    className="w-full px-3 py-2.5 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 placeholder:text-slate-400 outline-none resize-none focus:bg-white focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition"
                  />

                </div>

              </div>

            </div>



            {/* =================================================
                IMAGE
            ================================================= */}

            <div>

              <div className="flex items-center gap-2 mb-3">

                <div
                  className="w-8 h-8 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center"
                >
                  <MdImage size={18} />
                </div>

                <div>

                  <h3 className="text-sm font-semibold text-slate-800">
                    Attachment
                  </h3>

                  <p className="text-xs text-slate-400">
                    View or replace the query attachment
                  </p>

                </div>

              </div>

              {/* IMAGE PREVIEW AREA */}

              <div
                className="rounded-xl border border-slate-200 bg-slate-50 p-4"
              >

                <div
                  className="flex flex-col sm:flex-row gap-4"
                >

                  {/* EXISTING IMAGE */}

                  {existingImageUrl && (
                    <div className="flex-1">

                      <p className="text-[11px] uppercase tracking-wide font-semibold text-slate-400 mb-2">
                        Current Image
                      </p>

                      <div
                        className="w-full h-40 rounded-lg bg-white border border-slate-200 overflow-hidden"
                      >

                        <img
                          src={existingImageUrl}
                          alt="Existing query"
                          className="w-full h-full object-contain"
                        />

                      </div>

                    </div>
                  )}

                  {/* SELECTED IMAGE */}

                  {selectedImageUrl && (
                    <div className="flex-1">

                      <div className="flex items-center justify-between mb-2">

                        <p className="text-[11px] uppercase tracking-wide font-semibold text-slate-400">
                          New Image
                        </p>

                        <button
                          type="button"
                          onClick={
                            removeSelectedImage
                          }
                          className="text-red-500 hover:text-red-700 flex items-center gap-1 text-xs"
                        >
                          <MdDeleteOutline
                            size={16}
                          />
                          Remove
                        </button>

                      </div>

                      <div
                        className="w-full h-40 rounded-lg bg-white border border-sky-200 overflow-hidden"
                      >

                        <img
                          src={selectedImageUrl}
                          alt="Selected preview"
                          className="w-full h-full object-contain"
                        />

                      </div>

                    </div>
                  )}

                </div>

                {/* UPLOAD */}

                <label
                  htmlFor="edit-query-image"
                  className="mt-4 flex items-center justify-center gap-2 w-full h-10 rounded-lg border border-dashed border-slate-300 bg-white hover:bg-sky-50 hover:border-sky-300 text-slate-600 text-sm font-medium cursor-pointer transition"
                >

                  <MdAttachFile size={18} />

                  {selectedImage
                    ? "Choose another image"
                    : "Upload new image"}

                  <input
                    id="edit-query-image"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={
                      handleImageChange
                    }
                  />

                </label>

                <p className="text-[11px] text-slate-400 mt-2 text-center">
                  Maximum file size: 5 MB
                </p>

              </div>

            </div>

          </div>

        </div>

        {/* ===================================================
            FOOTER
        =================================================== */}

        <div
          className="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-3 px-5 sm:px-6 py-4 border-t border-slate-200 bg-slate-50 flex-shrink-0"
        >

          <p className="text-xs text-slate-400">
            Update the required fields and save your changes.
          </p>

          <div
            className="flex flex-col sm:flex-row gap-2"
          >

            {/* CANCEL */}

            <button
              type="button"
              onClick={closeModal}
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-slate-200 bg-white text-slate-600 text-sm font-semibold hover:bg-slate-100 transition"
            >
              <MdClose size={18} />
              Cancel
            </button>

            {/* UPDATE */}

            <button
              type="button"
              onClick={handleUpdate}
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold shadow-sm transition"
            >
              <MdSend size={18} />
              Update Query
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}